import { Button, Drawer, Stack, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { SyntheticEvent, useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  date1: { border: "1px solid red" },
}));

function ResetHostPool({
  open,
  rowHost,
  SaveChanges,
  onClose,
}: {
  open: boolean;
  rowHost: any;
  SaveChanges: any;
  onClose: any;
}) {
  const classes = useStyles();
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [openSnackBar, setOpen] = React.useState(false);

  function OnSaveClick() {
    SaveChanges(rowHost);
    setOpen(true);
  }

  React.useEffect(() => {
    SetOpenDrawer(open);
  }, [open]);

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant="success"
          message="Max Users Reset Done."
        />
      </Snackbar>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box>
              <TextField
                disabled
                required
                id="outlined-required"
                label="Server Name"
                value={rowHost.serverName}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                disabled
                required
                id="outlined-required"
                label="Number of Dealers"
                value={rowHost.numDealers}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                disabled
                required
                id="outlined-required"
                label="Number of Users"
                value={rowHost.numUsers}
                style={{ width: "300px" }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ padding: "10px", border: "0px solid red" }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={OnSaveClick}
            >
              Reset Host Pool
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default ResetHostPool;
